import { useEffect, useState } from 'react';
import { fetchOrphanObjectsKPI } from '../api/orphanObjectsApi';

export const useOrphanObjectsKpi = (activeFile = null) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = async (fileType) => {
    setLoading(true);
    setError(null);
    try {
      const effectiveFileType = fileType ?? activeFile ?? null;
      const kpi = await fetchOrphanObjectsKPI(effectiveFileType);
      setData(kpi);
    } catch (e) {
      setError(e?.message || 'Failed to load KPI');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setLoading(true);
      setError(null);
      try {
        const kpi = await fetchOrphanObjectsKPI(activeFile ?? null);
        if (!cancelled) setData(kpi);
      } catch (e) {
        if (!cancelled) setError(e?.message || 'Failed to load KPI');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, [activeFile]);

  return { data, loading, error, refresh: load };
};
